import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge, Subject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  public expired$: Subject<boolean> = new Subject<boolean>();
  private idle$: Observable<any>;
  private timer$;
  private timeOutMilliSeconds: number;
  private idleSubscription;

  /**
   * Start watching for given timeout seconds and return true if portal is idle for that time
   *
   * @param timeOutSeconds
   *
   */
  public startWatching(timeOutSeconds): Observable<any> {
    this.idle$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'click'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keypress'),
      fromEvent(document, 'DOMMouseScroll'),
      fromEvent(document, 'mousewheel'),
      fromEvent(document, 'touchmove'),
      fromEvent(document, 'MSPointerMove'),
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'resize')
    );

    this.timeOutMilliSeconds = timeOutSeconds * 1000;

    this.idleSubscription = this.idle$.subscribe(() => {
      this.resetTimer();
    });

    this.startTimer();

    return this.expired$;
  }

  /**
   * Reset timeout timer
   */
  public resetTimer() {
    this.timer$.unsubscribe();
    this.startTimer();
  }

  /**
   * Stop timeout timer
   */
  public stopTimer() {
    if (!!this.timer$) {
      this.timer$.unsubscribe();
    }
    if (!!this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
  }

  private startTimer() {
    this.timer$ = timer(this.timeOutMilliSeconds, this.timeOutMilliSeconds).subscribe(() => {
      this.expired$.next(true);
    });
  }
}
